// import { INAV_VARIANTS } from '../../utils/constants';

// const getExperimentDetails = ({
//   experimentName,
//   dimensionName,
//   defaultVariant = INAV_VARIANTS.CONTROL,
//   variants = [INAV_VARIANTS.CONTROL, INAV_VARIANTS.INAV_VAR_A],
// }) => ({
//   experimentName,
//   dimensionName,
//   defaultVariant,
//   variants,
// });

// CA Market Config
// control - axp-global-header, variantA - Simplified header
// showExitModal in props is to show the exit modal. This exit modal content is cusomtized
// showExitButtonInHeader - optional whether to show the leave application button in header or not
//  - This can be customized based on page in journey from your holocron using modalData.
// modal content can be passed from journey to root module using handleExitModal call back.
// Refer CA Market.
const caInavConfig = {
  props: {
    showExitModal: true,
    showExitButtonInHeader: true,
  },
  inavLiteJourney: {
    personal: {},
    sbs: {},
    docUpload: {
      hideExitBtnOnLoad: true,
    },
  },
  ignoreInavLiteModules: ['axp-retrieve-application'],
};

const gbInavConfig = {
  props: {
    showExitModal: true,
    showExitButtonInHeader: true,
    modalProps: {
      exitCtaPrimary: true,
    },
  },
  inavLiteJourney: {
    personal: {},
  },
  ignoreInavLiteModules: ['axp-retrieve-application'],
};

const mxInavConfig = {
  props: {
    showExitModal: true,
    showExitButtonInHeader: true,
  },
  inavLiteJourney: {
    personal: {},
    sbs: {},
  },
  ignoreInavLiteModules: ['axp-retrieve-application'],
};

const jpInavConfig = {
  props: {
    showExitModal: true,
    showExitButtonInHeader: false,
    modalProps: {
      exitButtonReactlytics: { element: 'ExitButton' },
      continueQuitModalReactlytics: { element: 'ExitButton', detail: 'Continue' },
      exitQuitModalReactlytics: { element: 'ExitButton', detail: 'Leave' },
    },
  },
  inavLiteJourney: {
    personal: {},
    sbs: {},
  },
  ignoreInavLiteModules: ['axp-retrieve-application'],
};

/**
 * If any market needs to have simple inav please add a config to your market.
 * `inavLiteJourney` is to determine, to which journey we need to show the inavLite.
 *     Add the journey="personal" or "sbs" as prop to your route in childRoutes.jsx
 * `ignoreInavLiteModules` -
 *    is to prevent loading inavLite to the whole module irrespective of any journey.
 * `props` -
 *    to control the additional feature for the inav, Ex:  browser close tab is part of this inav.
 * `experimentDetails` is to have different variants of inav running in experiments
 * If no config is given it will have control by default for all the route (axp-global-header)
 */
export const inavMarketsDetails = {
  'en-ca': caInavConfig,
  'fr-ca': caInavConfig,
  'en-gb': gbInavConfig,
  'es-mx': mxInavConfig,
  'ja-jp': jpInavConfig,
};
